import {
    Expander,
    ExpanderBorderRoundingStyle,
    ExpanderBorderStyle,
    ExpanderButtonStyle,
    ExpanderHeaderSpacing,
    ExpanderTheme,
} from '@apply/components';
import { LoanFileTypeOptions } from '@apply/constants';
import { useStandardLoanStore } from '../../../../../state/standardLoanStore';
import { LoanFilesTable } from '../../../../../../../../common/components/v2/LoanFilesTable/LoanFilesTable';
import '../styles/_sectionContent.scss';

/**
 * The Files section of the "Loan" step: a new version of EditStdLoanModal's Loan Files. The files are kept in the
 * standard loan store. As before, files can only be added once the loan has been saved.
 */
export const LoanFiles = () => {
    const loanFiles = useStandardLoanStore((state) => state.loanFiles);
    const setLoanFiles = useStandardLoanStore((state) => state.setLoanFiles);
    const isSavedLoan = useStandardLoanStore((state) => !!state.loadedLoan?.id);

    return (
        <Expander
            header={<h2>Files</h2>}
            initialExpanded={true}
            theme={ExpanderTheme.White}
            buttonStyle={ExpanderButtonStyle.NoRounding}
            borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
            borderStyle={ExpanderBorderStyle.None}
            headerSpacing={ExpanderHeaderSpacing.None}
            width='auto'
            height='30px'
        >
            <div className='loanSectionContent'>
                {isSavedLoan ? (
                    <LoanFilesTable
                        id='loanFiles'
                        files={loanFiles}
                        fileTypeOptions={LoanFileTypeOptions}
                        onChange={setLoanFiles}
                    />
                ) : (
                    <div style={{ color: 'silver' }}>Available after first save.</div>
                )}
            </div>
        </Expander>
    );
};
